//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { AUTH_REQUEST } from "../store/actions/auth.js";
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    submit() {
      const formData = new FormData();
      formData.append("username", this.email);
      formData.append("password", this.password);

      this.$store
        .dispatch(AUTH_REQUEST, formData)
        .then(() => {
          this.$router.push("/package");
        })
        .catch(err => {
          let status = err.response.status;
          if (status == 401) {
            this.$q.notify({
              type: "negative",
              message: `Incorrect username or password`
            });
          }
        });
    }
  }
};
